/* eslint-disable import/prefer-default-export */
import moment from "moment";

import { getSupaClient } from "../lib/supabase";

const queryString = require("query-string");
// const team_id = localStorage.getItem('team-id')

export const logout = async () => {
  const supabase = getSupaClient();
  localStorage.removeItem("team-id");
  localStorage.removeItem("team-name");
  localStorage.removeItem("teams");
  localStorage.removeItem("twitter-ids");
  localStorage.removeItem("dots-excluded");
  localStorage.removeItem("dots-keywords");
  localStorage.removeItem("slack-id");
  localStorage.removeItem("approved");
  localStorage.removeItem("platform");
  localStorage.removeItem("guild-id");
  localStorage.removeItem("guild-name");
  localStorage.removeItem("discord-id");
  localStorage.removeItem("discord-guilds");
  localStorage.removeItem("trial-end");
  localStorage.removeItem("paid");
  localStorage.removeItem("slack-teams");
  await supabase.auth.signOut(); // doesn't seem to work properly right now
  localStorage.removeItem("supabase.auth.token");
  window.posthog.reset(true);
};

// Post to our backend Lambda functions as the currently logged in user
export const lambdaPost = async (body, endpoint) => {
  const supabase = getSupaClient();
  body.session = supabase.auth.session();
  const initObj = {
    method: "post",
    headers: new Headers({ "Content-Type": "application/json" }),
    body,
  };
  if (body) {
    initObj.body = JSON.stringify(body);
  }
  const apiUrlFormatted = `${process.env.REACT_APP_API}/${endpoint}`;
  return fetch(apiUrlFormatted, initObj)
    .then((response) => response.json())
    .then((responseJSON) => {
      return responseJSON;
    })
    .catch(function (err) {
      console.log("error in lambdaPost", err);
      return { error: err };
    });
};

export const timeSince = (ts) => {
  let date;
  if (Date.parse(ts)) date = new Date(Date.parse(ts));
  else date = new Date(parseFloat(ts) * 1000);

  const seconds = Math.floor((new Date() - date) / 1000);
  let interval = seconds / 31536000;
  if (interval > 1) {
    return { text: `${Math.floor(interval)} y`, seconds };
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return { text: `${Math.floor(interval)} mt`, seconds };
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return { text: `${Math.floor(interval)} d`, seconds };
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return { text: `${Math.floor(interval)} hr`, seconds };
  }
  interval = seconds / 60;
  if (interval > 1) {
    return { text: `${Math.floor(interval)} m`, seconds };
  }
  return { text: `${Math.floor(seconds)} s`, seconds };
};

export const timeSinceUnformatted = (ts) => {
  return moment(ts).format("DD-MMM-YY");
};
